/* ============================================================
   SIMOVO Europe eSIM — shared section scripts
   File: assets/europe-esim.js
   Used by: bridge-banner, plans (tab switching, conversion tracking)
   ============================================================ */

(function() {
  'use strict';
  
  // Counter animation for the bridge banner
  function initCounter() {
    var counterEl = document.getElementById('countryCounter');
    if (!counterEl) return;
    
    var hasAnimated = false;
    var target = parseInt(counterEl.dataset.target || '34', 10);
    
    function animateCounter() {
      if (hasAnimated) return;
      hasAnimated = true;
      
      var duration = 1400;
      var startTime = performance.now();
      
      function tick(now) {
        var elapsed = now - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        counterEl.textContent = Math.floor(eased * target);
        
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          counterEl.textContent = target;
        }
      }
      
      counterEl.textContent = '0';
      requestAnimationFrame(tick);
    }
    
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            animateCounter();
            observer.disconnect();
          }
        });
      }, { threshold: 0.5 });
      observer.observe(counterEl);
    } else {
      animateCounter();
    }
  }
  
  // Plan tab switcher
  function initPlanTabs() {
    var tabs = document.querySelectorAll('.se-plans__tab');
    var panels = document.querySelectorAll('[data-tab-content]');
    
    if (!tabs.length || !panels.length) return;
    
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.dataset.tab;
        
        tabs.forEach(function(t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        
        panels.forEach(function(p) {
          p.hidden = p.dataset.tabContent !== target;
        });
        
        // Track tab switch for funnel analysis
        if (typeof gtag === 'function') {
          gtag('event', 'plans_tab_switch', {
            tab_name: target,
            page: 'europe-esim'
          });
        }
      });
    });
  }
  
  // Track plan card clicks for funnel analysis
  function initPlanTracking() {
    document.querySelectorAll('.se-plan-card').forEach(function(card) {
      card.addEventListener('click', function() {
        if (typeof gtag !== 'function') return;
        
        var dataAmount = card.querySelector('.se-plan-card__data');
        var price = card.querySelector('.se-plan-card__price');
        
        gtag('event', 'plan_select', {
          plan_data: dataAmount ? dataAmount.textContent : '',
          plan_price: price ? price.textContent : '',
          page: 'europe-esim'
        });
      });
    });
  }
  
  // Initialise everything once DOM is ready
  function init() {
    initCounter();
    initPlanTabs();
    initPlanTracking();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
